import clsx from "clsx"
export default function Change({ className = '' }) {
  return (
    <svg className={clsx(className, 'w-(--space-7) h-auto')} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16.375 7.25592L15.2437 6.17851L16.4812 5L19.7249 8.08926L16.4812 11.1785L15.2437 10L16.375 8.92259L7.11244 8.92259L7.11244 12.2559H5.36244L5.36244 7.25592H16.375Z" fill="#38362D"/>
      <path d="M8.34987 17.2559L9.48116 18.3333L8.24372 19.5118L5 16.4226L8.24372 13.3333L9.48116 14.5118L8.34988 15.5893L17.6124 15.5893L17.6124 12.2559H19.3624L19.3624 17.2559L8.34987 17.2559Z" fill="#38362D"/>
    </svg>
  )
}
